export enum Layer {
  DEFAULT = 0,
  LEFT = 1,
  RIGHT = 2,
  HIDE = 3,
}
